//import jwtDecode from "jwt-decode";

// const initialState = {
//     best_selling_products: [],
//     menu: [],
//     new_products: [],
//     sections: [],
//     special_offer_products: [],
//     sliders: []
// }
export const ui = (state = {}, action) => {
    switch (action.type) {
        case "UI": {
            return {
                menu: action.payload.menu,
                articles: action.payload.articles,
                about_video: action.payload.about_video,
                courses: action.payload.courses,
                category_parent: action.payload.categories,
                quick_news: action.payload.slider_text,
                sliders: action.payload.sliders,
                achievements: action.payload.achievements,
                background: action.payload.background,
                work_samples: action.payload.work_samples,
                story: action.payload.story,
                courses_with_offer: action.payload.courses_with_offer,
                faqs: action.payload.faqs,
                top_students : action.payload.top_students,
                vip_courses : action.payload.vip_courses,
                videos : action.payload.videos,
                statistics : action.payload.statistics,
                setting : action.payload.setting,
                student_satisfaction : action.payload.student_satisfaction,
                latest_courses : action.payload.latest_courses,
                experts : action.payload.experts,
                timeline : action.payload.timeline,
                sections: action.payload.sections,
            }
        }
        default: {
            return state
        }
    }
}
